import { gql } from "graphql-request";

export const user = {
  currentUser: gql`
    query CurrentUser($roleScope: String) {
      currentUser(roleScope: $roleScope) {
        id
        firstName
        lastName
        email
        status
        title
        org
        createdDate
        roles {
          roleId
          userId
          projects
        }
        preferences {
          timezone
          timezoneOffset
          isExternalIdpUser
          email {
            dailyDigest
            newProjectAccess
            externalUserActivatedAccount
          }
          emailGroups {
            dailyDigest
            projectAccessAndInvitations
            contentAndQuestions
            taskManagement
            milestones
          }
        }
        organization {
          id
          name
          shortName
          tenantId
          type
          country
          phones {
            phone
            phoneCountryPrefix
            phoneExtension
          }
          emails {
            emailAddress
          }
          addresses {
            address1
            address2
            city
            state
            country
            postcode
            poBox
            addressComplement
            isPrimary
          }
        }
        permissions {
          canAccessCCS
          canAccessUserManagement
          canAccessApp
          canAccessAdminPages
          canCreateOrganizationalAdminAccounts
          canDeactivateOrganizationalAdminAccounts
          canReactivateOrganizationalAdminAccounts
          canViewAllContent
          canAssignSelfAsPM
          canAssignUsersToProjectAtProjectCreation
          canCreateNewProject
          canViewAllProjectsForOrganization
          canDeleteAnyProjectsForOrganization
          canAccessStructuredDocumentReordering
          canCreateUserAccounts
          canBulkCreateUserAccounts
          canAssignUserTypeAccountToAUser
          canEditOwnAccountProfile
          canEditOtherAccountProperties
          canInactivateUserAccounts
          canInactivateExternalUserAccounts
          canReactivateUserAccounts
          canReactivateExternalUserAccounts
          canSelectOrganizationAtUserCreation
          canConfigureExternalUserActivatedAccountNotifications
          canResendActivationEmail
        }
      }
    }
  `,
  user: gql`
    query User($userId: String!, $roleScope: String) {
      user(userId: $userId, roleScope: $roleScope) {
        id
        firstName
        lastName
        email
        status
        title
        org
        createdDate
        roles {
          roleId
          userId
          projects
        }
        preferences {
          timezone
          timezoneOffset
          isExternalIdpUser
          email {
            dailyDigest
            newProjectAccess
            externalUserActivatedAccount
          }
          emailGroups {
            dailyDigest
            projectAccessAndInvitations
            contentAndQuestions
            taskManagement
            milestones
          }
        }
        organization {
          id
          name
          shortName
          tenantId
          type
          country
          parentId
          dunsNumber
          ebsClientId
          evCode
          externalId
          globalId
          masterFileType
          phones {
            phone
            phoneCountryPrefix
            phoneExtension
          }
          emails {
            emailAddress
          }
          addresses {
            address1
            address2
            city
            state
            country
            postcode
            poBox
            addressComplement
            isPrimary
          }
        }
      }
    }
  `,
  legalAcknowledgements: gql`
    query LegalAcknowledgement {
      legalAcknowledgements {
        id
        title
        body
      }
    }
  `,
};
